import _ from 'underscore';
import Backbone from 'backbone';
import { eventBus } from '../state-manager/event-bus';
import { state } from '../state-manager/state-model';
import { domainReplacer } from '../utils/domain-replacer';
import { LINKS } from '../config';

export var GiftCashView = Backbone.View.extend({
  el: '.app__gift-cash', // 서버사이드 렌더링

  initialize: function () {
    /**
     * NOTE: 모델이 필요없을 정도로 간단하기 때문에 여기서 피망캐쉬 상품 ID를 저장
     */
    this.productId = this.$el.find('.gift_list > li.on').eq(0).data('productId');

    this.categoryId = '1000007809'; // 고정
  },

  events: {
    'mouseover .selected, .gift_list': 'open',
    'mouseout .gift_list': 'close',
    'click li': 'select',
    'click .btn_gift': 'openGiftPopup'
  },

  render: function () {
    return this;
  },

  open: function () {
    this.$el.find('.gift_list').show();
  },

  close: function () {
    this.$el.find('.gift_list').hide();
  },

  select: function (e) {
    var $el = $(e.currentTarget);
    var currentPrice = $el.find('em > strong').html();

    $el.siblings().removeClass('on').end().addClass('on');

    this.$el.find('.selected > em > strong').html(currentPrice);
    this.close();

    this.productId = $el.data('productId');
  },

  openGiftPopup: function (e) {
    if (e && _.isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    var ssn = state.get('ssn');
    var replaceURL = domainReplacer.create();

    var url = [
      replaceURL(LINKS.pmangCashPresent),
      '?ssn=',
      ssn,
      '&product_id_list=',
      this.productId,
      '&cat_id=',
      this.categoryId,
      '&sellplace=W',
      '&is_gift=Y'
    ].join('');

    eventBus.trigger('open:popup', {
      href: url,
      name: '_buy',
      width: 400,
      height: 400,
      scrollbars: 'no',
      onClose: 'app:userInfoView:refresh'
    });
  }
});
